$(document).ready(function () {
   $('.header__menu a[href="#"]').click(function (e){
       e.preventDefault();
   })

  if ($(window).width() < 992) {
     $('.header li.header__item.has-submenu a[href="#"]').click(function(){
       $(this).next('ul.submenu').toggle();
     })
  }

  let offtop;
  
  if( !$.trim( $('#shopify-section-announcement-bar').html() ).length ) {
      offtop = 0;
    }else{
      offtop = 60;
    }
  
  
  console.log(offtop);
  
  $(window).scroll(function () {
    var $this = $(this),
        $head = $('header');
    
    if ($this.scrollTop() > offtop) {
       $head.addClass('fixtop');
    } else {
       $head.removeClass('fixtop');
    }
});
});